import type { CompanyTechnologyNestedSelectDto } from '@@types/api.types';
import { formatProper } from '@utils/text.util';

export const buildCompanyLocationDisplay = (company: CompanyTechnologyNestedSelectDto): string | undefined => {
  const parts = [company.city, company.state, company.country].filter(Boolean);
  return parts.length > 0 ? parts.join(', ') : undefined;
};

export const formatCompanyType = (companyType?: string): string | undefined => {
  if (!companyType) return undefined;
  return formatProper(companyType.toLowerCase().replace(/_/g, ' '));
};
